import toast from "react-hot-toast";
import * as requestFromServer from "./zatcaCrud";
import { callTypes, zatcaSlice } from "./zatcaSlice";

const { actions } = zatcaSlice;

export const OnboardPosToZatca = (storeId, otp, type, setShowCertificateDetails, toastId,timezone) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .OnboardPosToZatca(storeId, otp, type,timezone)
    .then((res) => {
      // toast.success(res?.data?.message);
      toast.success("ZATCA onboarding completed successfully", {
        id: toastId,
      });
      setShowCertificateDetails(true);
    })
    .catch((error) => {
      toast.error(error?.response?.data?.message, {
        id: toastId,
      });

      error.clientMessage = "Can't find users";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const getAllZatcaOnboardingLogs = (companyId, searchData) => (dispatch) => {
  actions.startCall({ callTypes: callTypes.list });
  return requestFromServer
    .getZatcaOnboardingLogs(companyId, searchData)
    .then((res) => {
      dispatch(
        actions.getZatcaOnboardingLogs({
          logs: res.data.logs,
          totalCount: res.data.totalCount,
          allLogsCount: res.data.allLogsCount,
        }),
      );
    })
    .catch((error) => {
      error.clientMessage = error.message;
      dispatch(
        actions.catchError({
          error,
          callType: callTypes.action,
        }),
      );
    });
};

export const expireCertificateInTwoMinutes = (posId) => (dispatch) => {
  actions.startCall({ callTypes: callTypes.list });
  return requestFromServer
    .expireCertificateInTwoMinutes(posId)
    .then((res) => {
      toast.success("ZATCA certificate set to expire in 2 minutes");
    })
    .catch((error) => {
      toast.error(error?.message);
      error.clientMessage = error.message;
      dispatch(
        actions.catchError({
          error,
          callType: callTypes.action,
        }),
      );
    });
};
export const reportInvoiceToZatca = (invoiceId, setToPending, setShowInvoiceStatusText, language) => (dispatch) => {
  actions.startCall({ callTypes: callTypes.list });
  return requestFromServer
    .reportInvoiceToZatca(invoiceId, setToPending)
    .then((res) => {
      if (
        res?.data?.status === false &&
        res?.data?.message !== "ZATCA certificate for this POS has expired. Please re-onboard the device." &&
        !res?.data?.data?.errorMessages[0]?.includes("Store address structure is invalid")
      ) {
        toast.error("Failed to Report to ZATCA");
        setShowInvoiceStatusText({ isProgress: false });
      } else if (res?.data?.status === false && res?.data?.message === "ZATCA certificate for this POS has expired. Please re-onboard the device.") {
        toast.error("ZATCA certificate for this POS has expired. Please re-onboard the device.");
        setShowInvoiceStatusText({ isProgress: false });
      } else if (res?.data?.status === false && res?.data?.data?.errorMessages[0]?.includes("Store address structure is invalid")) {
        toast.error("Store address structure is invalid");
        setShowInvoiceStatusText({ isProgress: false });
      } else if (res?.data?.status === false) {
        toast.error(res?.data?.message);
        setShowInvoiceStatusText({ isProgress: false });
      } else {
        toast.success("Invoice Reported Successfully");
        setShowInvoiceStatusText({ isProgress: false, success: true });
      }
    })
    .catch((error) => {
      let translatedMessage = error?.response?.data?.message?.includes("ZATCA certificate for this POS has expired")
        ? language === "arabic"
          ? "تعذر إعادة الإرسال، شهادة زاتكا منتهية."
          : "Unable to resend, ZATCA certificate expired."
        : error?.reponse?.data?.data?.errorMessages[0]?.includes("Store address structure is invalid")
        ? "Store address structure is invalid"
        : error?.response?.data?.message || error?.message;

      // toast.error(error?.message);
      toast.error(translatedMessage);
      setShowInvoiceStatusText({ isProgress: false });
      error.clientMessage = translatedMessage;
      // error.clientMessage = error.message;
      dispatch(
        actions.catchError({
          error,
          callType: callTypes.action,
        }),
      );
    });
};

export const createInvoiceXmlDownloadLogs = (companyId, invoiceId, logMessage, fileName) => (dispatch) => {
  actions.startCall({ callTypes: callTypes.list });
  return requestFromServer
    .createInvoiceXmlDownloadLogs(companyId, invoiceId, logMessage, fileName)
    .then((res) => {
      // toast.success("ZATCA certificate set to expire in 2 minutes");
    })
    .catch((error) => {
      toast.error(error?.message);
      error.clientMessage = error.message;
      dispatch(
        actions.catchError({
          error,
          callType: callTypes.action,
        }),
      );
    });
};

export const revokePosCertificate = (posId, forceRevokeFailure,timezone) => (dispatch) => {
  actions.startCall({ callTypes: callTypes.list });
  return requestFromServer
    .revokePosCertificate(posId, forceRevokeFailure,timezone)
    .then((res) => {
      toast.success("Certificate Revoked successfully");
    })
    .catch((error) => {
      toast.error(error?.response?.data?.message);
      error.clientMessage = error?.response?.data?.message;
      dispatch(
        actions.catchError({
          error,
          callType: callTypes.action,
        }),
      );
    });
};
